import { render, staticRenderFns } from "./ObservacionMagistrado.vue?vue&type=template&id=1895d5a1&"
import script from "./ObservacionMagistrado.vue?vue&type=script&lang=js&"
export * from "./ObservacionMagistrado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports